import { render, staticRenderFns } from "./resetPasswordOnEmail.vue?vue&type=template&id=e61b3998&scoped=true"
import script from "./resetPasswordOnEmail.vue?vue&type=script&lang=js"
export * from "./resetPasswordOnEmail.vue?vue&type=script&lang=js"
import style0 from "./resetPasswordOnEmail.vue?vue&type=style&index=0&id=e61b3998&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61b3998",
  null
  
)

export default component.exports